import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Button, Spacer, Icon, Text, Flexer } from '@ontruck/orc';
import { Loading } from 'components/Loading';

import AssignAgentSelector from 'modules/journey/AssignAgentSelector';
import { injectIntl } from 'react-intl';

const AssignAgentModal = ({
  loading,
  className,
  onAssign,
  onSelect,
  selectedAgent,
  title,
  show,
  onClose,
  warning,
  intl,
}) => {
  const t = intl.messages.modules.assign_agent_modal;
  return (
    <Modal
      show={show}
      size="S"
      allowClose
      closeButton
      onClose={onClose}
      headerComponent={title || t.assign}
      onTop
      visibleOverflow
    >
      <div className={className}>
        {loading && (
          <div className="assign-agent-modal__loading">
            <Loading />
          </div>
        )}
        <Spacer mBottom="S">
          <AssignAgentSelector value={selectedAgent} onChange={onSelect} />
        </Spacer>
        {!!warning && !!selectedAgent && Object.keys(selectedAgent).length > 0 && (
          <Spacer mBottom="S" mRight="S" data-testid="warning-container">
            <Flexer.Parent>
              <Flexer.Child mRight="XS">
                <Icon glyph="girded-info" size="1.6rem" color="accent700" />
              </Flexer.Child>
              <Flexer.Child>
                <Text text={warning} color="accent700" />
              </Flexer.Child>
            </Flexer.Parent>
          </Spacer>
        )}
        <Button disabled={!selectedAgent} fullWidth onClick={onAssign} text={t.assign} />
      </div>
    </Modal>
  );
};

AssignAgentModal.propTypes = {
  onAssign: PropTypes.func,
  onSelect: PropTypes.func,
  selectedAgent: PropTypes.object,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  loading: PropTypes.bool,
};

export default injectIntl(AssignAgentModal);
